module.exports = __webpack_public_path__ + "static/media/sketch2.58a921e5.jpg";